import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { Helmet } from 'react-helmet-async';

import LeftSidebar from './Common/LeftSidebar';

const AboutWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  max-width: 45em;
  font-size: 0.85em;
`;

const AboutContent = styled.div`
  text-align: left;
`;

const Banner = styled.img`
  max-width: 100%;
  margin-left: -1em;
`;

const AboutHero = styled.div`
  font-size: 1.2em;
  font-weight: bold;
  margin-bottom: 1em;
`;

const About = () => {
  const pageTitle = "About - Oracle's Elixir";
  const pageDescription =
    "About Oracle's Elixir, the premier source for advanced Valorant esports stats.";

  return (
    <>
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={pageDescription} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@TimSevenhuysen" />
        <meta name="twitter:title" content={pageTitle} />
        <meta name="twitter:description" content={pageDescription} />
      </Helmet>
      <LeftSidebar />
      <AboutWrapper className="mainContent">
        <AboutContent>
          <Banner src="/OE-Wordmark-Gradient.png" />
          <AboutHero>
            The premier source for advanced VALORANT esports stats.
          </AboutHero>
          <p>
            Since 2015, esports stats and analysis from <em>Oracle's Elixir</em>{" "}
            have been relied on by professional coaches, analysts, broadcasters,
            writers, daily fantasy competitors, and hardcore fans. Now OE has
            extended its coverage to VALORANT, bringing you the same groundbreaking
            insights in a classic esports genre.
          </p>
          <p>
            Whatever league or region you follow, <em>Oracle's Elixir</em> is where
            you will find the most comprehensive, in-depth player and team analytics.
          </p>
          <p>
            If you have questions about this site and its contents, feel free to{" "}
            <Link to="/contact">contact the founder</Link>, Tim Sevenhuysen, or{" "}
            <a
              href="https://discord.gg/KY6XHaF"
              target="_blank"
              rel="noopener noreferrer"
            >
              join the Oracle's Elixir Discord server
            </a>
            .
          </p>
          <p>
            If usage terms regarding specific <em>Oracle's Elixir</em> content are unclear,{" "}
            <Link to="/contact">contact Tim Sevenhuysen</Link> with your questions to clarify what
            is and is not permitted.
          </p>
          <hr />
          <p>
            <span style={{ 'fontWeight': 'bold', 'fontSize': '1.1em' }}>
              <em>Oracle's Elixir</em> is powered by data from <a
                href='https://grid.gg'
                target="_blank"
                rel="noopener noreferrer"
              >GRID esports</a>.</span><br />
            <a
              href='https://grid.gg'
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src='/grid_badge.png'
                style={{ 'float': 'right', 'width': '10em' }}
                alt='GRID esports logo'
              />
            </a>
            The GRID Data Platform serves the game industry with in-game data infrastructure, data management, and asset distribution solutions.

            Built by passionate gamers with unmatched business expertise in sports data, betting, game development, big tech, and esports to unlock the potential of in-game data for everyone.
          </p>
          <hr />
          <p>
            <em>Oracle's Elixir</em> is not endorsed by Riot Games and doesn't
            reflect the views or opinions of Riot Games or anyone officially
            involved in producing or managing VALORANT. VALORANT and Riot Games
            are trademarks or registered trademarks of Riot Games, Inc.
            VALORANT © Riot Games, Inc.
          </p>
        </AboutContent>
      </AboutWrapper>
    </>
  );
};

export default About;
